export default __webpack_public_path__ + "static/media/cxcu_logo.b0715e94.webp";